<script>
  import conciliacaoProjetoServico from '../servico';
  import { abrirBlob, dicaAbrir } from '~js/abrir-arquivo';

  const ICONES = {
    'lancamento': 'fa-file-text-o',
    'conta-receber': 'fa-download',
    'sol-pagamento': 'fa-credit-card',
    'sol-reembolso': 'fa-undo',
    'sol-adiantamento': 'fa-forward',
  };

  export default {
    props: {
      lancamento: { type: Object, required: true },
    },
    data() {
      return { carregando: true, erro: '', grupos: [], abrindo: '' };
    },
    computed: {
      dicaAbrir,
      total() { return this.grupos.reduce((s, g) => s + g.arquivos.length, 0); },
      subtitulo() {
        const l = this.lancamento;
        return ['Lançamento ' + l.idLancamento, l.dataStr, l.historico].filter(Boolean).join(' · ');
      },
    },
    created() { this.carregar(); },
    methods: {
      carregar() {
        this.carregando = true; this.erro = '';
        conciliacaoProjetoServico.arquivosLancamento(this.lancamento.idLancamento)
          .then(d => { this.grupos = d || []; this.carregando = false; })
          .catch(e => {
            this.carregando = false;
            this.erro = (e && e.body && e.body.message) || 'Não foi possível listar os arquivos do lançamento.';
          });
      },
      icone(g) { return ICONES[g.fonte] || 'fa-folder-o'; },
      chave(g, nome) { return g.fonte + '|' + nome; },
      abrir(g, nome) {
        this.abrindo = this.chave(g, nome);
        conciliacaoProjetoServico.arquivoLancamento(this.lancamento.idLancamento, g.fonte, nome)
          .then(blob => {
            this.abrindo = '';
            abrirBlob(blob, nome);
          })
          .catch(() => {
            this.abrindo = '';
            toastr.error('Não foi possível abrir o arquivo ' + nome + '.');
          });
      },
    },
  };
</script>

<template>
  <div class="arl-ov">
    <div class="arl-modal" role="dialog" aria-modal="true" aria-label="Arquivos do lançamento">
      <div class="arl-head">
        <div class="arl-head-ic"><i class="fa fa-paperclip"></i></div>
        <div class="arl-head-txt">
          <h4>Arquivos do lançamento</h4>
          <small :title="subtitulo">{{ subtitulo }}</small>
        </div>
        <div v-if="total" class="arl-head-resumo"><b>{{ total }}</b> arquivo{{ total > 1 ? 's' : '' }}</div>
      </div>

      <div class="arl-corpo">
        <div v-if="carregando" class="arl-msg"><i class="fa fa-spinner fa-pulse"></i> Lendo a pasta do lançamento…</div>
        <div v-else-if="erro" class="arl-msg arl-msg-erro"><i class="fa fa-exclamation-triangle"></i> {{ erro }}</div>
        <div v-else-if="!grupos.length" class="arl-vazio">
          <i class="fa fa-folder-open-o"></i>
          <b>Nenhum arquivo</b>
          <span>A pasta do lançamento e as das solicitações vinculadas estão vazias.</span>
        </div>
        <div v-else v-for="g in grupos" :key="g.fonte" class="arl-grupo">
          <div class="arl-grupo-tit"><i class="fa" :class="icone(g)"></i> {{ g.titulo }} <span class="mono">{{ g.id }}</span></div>
          <button v-for="n in g.arquivos" :key="chave(g, n)" type="button" class="arl-arq" :disabled="abrindo === chave(g, n)" @click="abrir(g, n)" :title="dicaAbrir">
            <i class="fa" :class="abrindo === chave(g, n) ? 'fa-spinner fa-pulse' : 'fa-file-o'"></i>
            <span class="arl-nome">{{ n }}</span>
            <i class="fa fa-external-link arl-abrir"></i>
          </button>
        </div>
      </div>

      <div class="arl-foot">
        <button type="button" class="arl-sair" @click="$emit('fechar')"><i class="fa fa-sign-out"></i> Sair</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .arl-ov { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(16,24,40,.45); z-index: 2100; display: flex; align-items: center; justify-content: center; padding: 16px; }
  .arl-modal { width: 620px; max-width: 97vw; max-height: 86vh; display: flex; flex-direction: column; background: #fff; border-radius: 8px; box-shadow: 0 18px 48px rgba(16,24,40,.28); overflow: hidden; }
  .arl-head { flex: 0 0 auto; display: flex; align-items: center; gap: 14px; padding: 15px 20px; background: #f7f9fa; border-bottom: 1px solid #e6e9ed; }
  .arl-head-ic { flex: none; width: 38px; height: 38px; border-radius: 8px; background: #e8f5ef; color: #0a6d4d; display: flex; align-items: center; justify-content: center; font-size: 18px; }
  .arl-head-txt { flex: 1 1 auto; min-width: 0; }
  .arl-head-txt h4 { margin: 0; font-size: 16px; font-weight: 600; color: #1c2024; }
  .arl-head-txt small { display: block; margin-top: 2px; font-size: 12px; color: #6b747e; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .arl-head-resumo { flex: none; font-size: 13px; color: #4b545e; }
  .arl-head-resumo b { font-size: 18px; color: #1c2024; }

  .arl-corpo { flex: 1 1 auto; min-height: 160px; overflow: auto; padding: 8px 20px 16px; }
  .arl-msg { padding: 40px 10px; text-align: center; color: #8a939c; font-size: 13px; }
  .arl-msg-erro { color: #a13c3c; }
  .arl-vazio { display: flex; flex-direction: column; align-items: center; gap: 6px; padding: 40px 16px; text-align: center; color: #6b747e; font-size: 12.5px; }
  .arl-vazio > .fa { font-size: 30px; color: #b9c8da; }
  .arl-vazio > b { font-size: 14px; color: #3b444d; }

  .arl-grupo { margin-top: 10px; }
  .arl-grupo-tit { font-size: 11.5px; font-weight: 700; letter-spacing: .03em; color: #4b545e; text-transform: uppercase; padding: 4px 0 6px; }
  .arl-grupo-tit .fa { color: #0f8a5f; margin-right: 4px; }
  .arl-grupo-tit .mono { font-weight: 500; color: #8a939c; margin-left: 4px; text-transform: none; }
  .arl-arq { display: flex; align-items: center; gap: 10px; width: 100%; text-align: left; padding: 8px 12px; margin-bottom: 6px; border: 1px solid #e3e8ee; border-radius: 7px; background: #fff; font-size: 12.5px; color: #1c2024; }
  .arl-arq:hover { border-color: #9fd3bd; background: #f4fbf8; }
  .arl-arq > .fa:first-child { color: #6b747e; }
  .arl-nome { flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .arl-abrir { color: #9aa3ac; }
  .arl-arq:hover .arl-abrir { color: #0f8a5f; }

  .arl-foot { flex: 0 0 auto; display: flex; justify-content: flex-end; padding: 12px 20px; border-top: 1px solid #e6eaee; }
  .arl-sair { display: inline-flex; align-items: center; gap: 7px; background: #fdf1f1; border: 1px solid #e4d7d7; border-radius: 5px; padding: 8px 18px; font-size: 12.5px; color: #a13c3c; font-weight: 600; }
  .arl-sair:hover { background: #fbe6e6; }
  .mono { font-family: 'IBM Plex Mono', Consolas, monospace; font-variant-numeric: tabular-nums; }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/ArquivosLancamentoModal.vue